import { ConfigProps } from "../common/types";

export const defaultConfig: ConfigProps = {
    cadlVersion: 'test',
    env: 'development',
    configUrl: 'https://public.aitmed.com/config',
}

